import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import routes from '../../common/models/route-constants';
import NotFoundPage from '../../common/pages/NotFoundPage';
import CreateTileLogoPage from '../pages/CreateTileLogoPage';
import TileLogoHomePage from '../pages/TileLogoHomePage';
import UpdateTileLogoPage from '../pages/UpdateTileLogoPage';

function TileLogoAssetsRouter() {
    let { path } = useRouteMatch();
    return (
        <React.Fragment>
            <Switch>
                <Route exact path={path}>
                    <TileLogoHomePage />
                </Route>
                <Route exact path={`${path}/${routes.CREATE}`}>
                    <CreateTileLogoPage />
                </Route>
                <Route exact path={`${path}/:id`}>
                    <UpdateTileLogoPage />
                </Route>
                <Route path='*'>
                    <NotFoundPage />
                </Route>
            </Switch>
        </React.Fragment>
    );
}

export default TileLogoAssetsRouter;
